import { ThemeAppearance } from '@atlaskit/lozenge';

import { OvertimeUndertimeStatus } from 'features/overtimeUndertime/types';

import { CompensationRequestStatus, RequestStatus, ResolutionStatus } from './constants';

export const requestStatusAppearance: { [key: string]: ThemeAppearance } = {
  [RequestStatus.approved]: 'success',
  [RequestStatus.declined]: 'removed',
  [RequestStatus.in_progress]: 'default',
  [RequestStatus.new]: 'default',
  [RequestStatus.canceled]: 'removed',
} as const;

export const compensationRequestStatusAppearance: { [key: string]: ThemeAppearance } = {
  [CompensationRequestStatus.approved]: 'success',
  [CompensationRequestStatus.declined]: 'removed',
  [CompensationRequestStatus.in_progress]: 'default',
  [CompensationRequestStatus.new]: 'inprogress',
  [CompensationRequestStatus.needs_update]: 'removed',
  ['pending']: 'inprogress',
  ['needs_corrections']: 'removed',
} as const;

export const resolutionStatusAppearance: { [key: string]: ThemeAppearance } = {
  [ResolutionStatus.approved]: 'success',
  [ResolutionStatus.declined]: 'removed',
  [ResolutionStatus.in_progress]: 'default',
  [ResolutionStatus.canceled]: 'removed',
} as const;

export const overtimeUndertimeStatusAppearance: { [key: string]: ThemeAppearance } = {
  [OvertimeUndertimeStatus.not_resolved]: 'default',
  [OvertimeUndertimeStatus.paid_standard]: 'inprogress',
  [OvertimeUndertimeStatus.paid_as_logged]: 'inprogress',
  [OvertimeUndertimeStatus.approved_change]: 'success',
  [OvertimeUndertimeStatus.reassigned]: 'new',
};

export const questionnaireStatusAppearance: { [key: string]: ThemeAppearance } = {
  SCHEDULED: 'inprogress',
  ONGOING: 'default',
  COMPLETED: 'success',
} as const;
